import WorkshopsMapBlock from './WorkshopsMapBlock';

export default WorkshopsMapBlock;
